import SummaryContent from '@/components/booking-summary/SummaryContent';
import { Icons } from '@/components/icons';
import PriceDisplay from '@/components/PriceDisplay';
import { CardPrimitiveRoot } from '@/components/primitives/Card';
import Divider from '@/components/primitives/Divider';
import { Typography } from '@/components/primitives/Typography';
import type { BookingSummaryData } from '@/hooks/useBookingSummaryData';
import { TransText } from '@/i18n/trans/text';
import type { FC } from 'react';

const RegularBookingSummary: FC<BookingSummaryData> = ({
  displayPrice,
  ...props
}) => {
  return (
    <CardPrimitiveRoot className="w-[320px]">
      <SummaryContent {...props} />
      <Divider variant="medium" className="border-primary" />
      <div className="flex flex-row justify-between p-4">
        <div className="flex gap-2">
          <Icons.shoppingCart className="text-primary" />
          <Typography variant="body1-bold">
            <TransText i18nKey="totalPrice" />
          </Typography>
        </div>
        <Typography variant="subtitle" className="text-primary">
          <PriceDisplay amount={displayPrice?.amount} />
        </Typography>
      </div>
    </CardPrimitiveRoot>
  );
};

export default RegularBookingSummary;
